export default class Workflow {
  constructor (workflow) {
    this.id = workflow.id
    this.workflow = workflow.workflow
    this.date = workflow.date
  }
}
